import { render, staticRenderFns } from "./purchaseInfo.vue?vue&type=template&id=581464ca&scoped=true&"
import script from "./purchaseInfo.vue?vue&type=script&lang=js&"
export * from "./purchaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./purchaseInfo.vue?vue&type=style&index=0&id=581464ca&prod&lang=less&"
import style1 from "./purchaseInfo.vue?vue&type=style&index=1&id=581464ca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581464ca",
  null
  
)

export default component.exports